<script setup lang="ts">
import { onMounted, ref } from "vue";

import { LoadingIcon } from "~/icons";
import { timeout } from "~/utils/wait";

const props = defineProps<{
  absolute?: boolean;
  small?: boolean;
  xSmall?: boolean;
  tiny?: boolean;
  immediate?: boolean;
}>();

const isShown = ref(props.immediate);
const isVisible = ref(props.immediate);

onMounted(async () => {
  if (props.immediate) {
    return;
  }

  await timeout(300);
  isShown.value = true;
  requestAnimationFrame(() => {
    isVisible.value = true;
  });
});
</script>

<template>
  <div
    v-if="isShown"
    class="pointer-events-none flex w-full items-center justify-center transition-opacity duration-300 ease-in-out"
    :class="[absolute && 'absolute inset-0', isVisible ? 'opacity-100' : 'opacity-0']">
    <LoadingIcon
      class="animate-spin text-vlt"
      :class="[small ? 'size-6' : xSmall ? 'size-4' : tiny ? 'size-3' : 'size-8']" />
  </div>
</template>
